/**
 * Tracks which images actually exist in the `nifty-uploads` Storage bucket,
 * so collection / region grids can hide records whose image would 404.
 *
 * Implementation: a static manifest file shipped at /public/uploads-manifest.json
 * (regenerated by `scripts/migration/refresh-uploads-manifest.mjs`).
 *
 * Why a static file and not Storage.list()? — Supabase Storage's RLS blocks
 * the anon role from listing buckets, so a runtime list() returns [] from the
 * browser. A static manifest is cheap (one ~7 KB fetch per session, cached)
 * and works without adding RLS policies.
 */

let _known: Promise<Set<string>> | null = null;

export function getKnownUploads(): Promise<Set<string>> {
  if (_known) return _known;
  _known = (async () => {
    try {
      const res = await fetch("/uploads-manifest.json", { cache: "force-cache" });
      if (!res.ok) {
        console.error("uploads manifest fetch failed:", res.status);
        return new Set<string>();
      }
      const arr = (await res.json()) as string[];
      return new Set(arr);
    } catch (e) {
      console.error("uploads manifest fetch failed:", e);
      return new Set<string>();
    }
  })();
  return _known;
}

export function hasUploadedImage(
  image: string | null | undefined,
  known: Set<string>
): boolean {
  if (!image || typeof image !== "string") return false;
  const filename = image.split("/").pop() || "";
  return known.has(filename);
}
